angular.module('trainerWebApp.controllers')
  .controller('CreatePageCtrl', ['$scope', '$location', '$timeout', 'trackingService', 'actionLogResource', 'mtypes', function ($scope, $location, $timeout, trackingService, actionLogResource, mtypes) {
    var gaActions = trackingService.pages.getStarted.actions;

    $scope.goToTrainerHome = function () {
      trackGS(gaActions.GettingStartedCreatePage_StartCreatingCourses);
      $location.path('/TMS/Home');
    };

    $scope.goToDistribute = function () {
      trackGS(gaActions.GettingStartedCreatePage_DistributePageButton);
      $location.path('/getStartedDistribute');
    };

    function trackGS(eventName) {
      trackingService.trackEvent(trackingService.pages.getStarted.name, eventName);
    }

    var findZendeskWidgetPromise = null;
    var zendeskWidget = null;
    function findZendeskWidget() {
      findZendeskWidgetPromise = $timeout(function () {
        zendeskWidget = angular.element('#launcher');
        if (!zendeskWidget || zendeskWidget.length == 0)
          return findZendeskWidget();
        zendeskWidget.css('visibility', 'hidden');
        $timeout.cancel(findZendeskWidgetPromise);
      }, 250);
    }

    var findIntercomWidgetPromise = null;
    var intercomWidget = null;
    function findIntercomWidget() {
      findIntercomWidgetPromise = $timeout(function () {
        intercomWidget = angular.element('#intercom-container');
        if (!intercomWidget || intercomWidget.length == 0)
          return findIntercomWidget();
        intercomWidget.css('display', 'inline');
        $timeout.cancel(findIntercomWidgetPromise);
      })
    }

    $scope.$on('$destroy', function () {
      $timeout.cancel(findZendeskWidgetPromise);
      $timeout.cancel(findIntercomWidgetPromise);
      if (zendeskWidget)
        zendeskWidget.css('visibility', 'visible');
      if (intercomWidget)
        intercomWidget.css('display', 'none');
    });

    trackGS(gaActions.GettingStartedCreatePage);
    actionLogResource.writeActionLog([{action: mtypes.actionType.gettingStartedTourCreatePage}]);
    findZendeskWidget();
    findIntercomWidget();
  }]);
